<template>
    <div class="con">
        <p class="more">探索更多
            <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i></p>
    </div>
</template>

<script>
    export default {
        name: "btn"
    }
</script>

<style lang="scss" scoped>
.con{
    .more{
        color:#979797;
        font-size: 14px;
        font-family: "Microsoft YaHei UI Light";
        padding-top: 20px;
        transition: all 1s;
        i{
            padding-left: 10px;
        }
    }
}
</style>